import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class BadDebtExpenseListItem extends SearchModelBase {
    id: number = 0;
    postdate: string | null = null;
    fromPostdate: string | null = null;
    toPostdate: string | null = null;
    entity: string = '';
    currency: string = '';
    amount: number|null = null;
    fromAmount: number|null = null;
    toAmount: number|null = null;
    remark: string = '';
    u1Date: string | null = null;
    fromU1Date: string | null = null;
    toU1Date: string | null = null;
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    u2ID: string = '';
    u1ID: string = '';
    status: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        // XCol.Create({ col: 1, text: 'V', width: 40, dataIndex: 'void', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        XCol.Create({ col: 2, text: 'Date', width: 75, dataIndex: 'postdate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 3, text: 'Entity', width: 150, dataIndex: 'entity', defaultColumnFocus : true}),
        XCol.Create({ col: 4, text: 'CUR', width: 40, dataIndex: 'currency', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 5, text: 'Amount', width: 100, dataIndex: 'amount', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 6, text: 'Remark', width: 200, dataIndex: 'remark'}),
        XCol.Create({ col: 7, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 8, text: 'Create by', width: 100, dataIndex: 'u1ID'}),
        XCol.Create({ col: 9, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 10, text: 'Update by', width: 100, dataIndex: 'u2ID'}),
        ];

    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection; 
    };
	
    public static OrderBy = { orderBy: BadDebtExpenseListItem.prototype.postdate, orderByAscending: false };

    public static formatData(data: BadDebtExpenseListItem[]) {
        return data.map((d: BadDebtExpenseListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        postdate: {from: 'fromPostdate', to: 'toPostdate'},
        u1Date: {from: 'fromU1Date', to: 'toU1Date'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
        amount: {from: 'fromAmount', to: 'toAmount'},
    }
}
